<template>
    <section class="product-main w-100 h-100">
        <template v-if="!loaded">
            <div v-if="getUser && !getUser.hasTerminal">
                <alert-main title="У вас не настроен терминал." :description="alertTerminalDescription"/>
            </div>
            <slot/>
            <policy-history-popup :product="product"/>
        </template>
        <loader-full v-else :text="loaderText"/>
        <alert-modal title="У вас не настроен терминал!"
                       :description="alertTerminalDescription"
                       :timer="3"/>
    </section>
</template>

<script>
import PolicyHistoryPopup from "@/components/Policy/PolicyHistoryPopup.vue";
import LoaderFull from "@/components/Main/LoaderFull.vue";
import AlertModal from "@/components/Main/AlertModal.vue";
import AlertMain from "@/components/Main/AlertMain.vue";

export default {
  name: "ProductMain",
  components: {
    PolicyHistoryPopup,
    LoaderFull,
    AlertModal,
    AlertMain
  },
  computed: {
    alertTerminalDescription() {
      return "Пожалуйста, обратитесь к ответственному бухгалтеру. <br/>Если терминал настроен, необходимо обновить токен или вновь авторизоваться.<br/><br/>Без терминала нельзя заключить полис!";
    },
    getUser() {
      return this.$store.state.user
    }
  },
  props: {
    loaded: {
      type: Boolean,
      default: false
    },
    product: {
      type: String,
      required: true
    },
    loaderText: {
      type: String,
      default: "Загрузка..."
    }
  }
};
</script>

<style scoped>
.product-main {
  position: relative;
}
</style>
